import { Box, Grid, Stack } from "@mui/material";
import type { ReactNode } from "react";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  isError: boolean;
  pointsTile: ReactNode;
  payoutTile: ReactNode;
  rewardsTile: ReactNode;
  myShareTile: ReactNode;
  rulesLink: ReactNode;
};

export const Overview = ({
  isError,
  pointsTile,
  payoutTile,
  rewardsTile,
  myShareTile,
  rulesLink,
}: Props) => {
  const { t } = useResource();

  if (isError) {
    return (
      <Stack gap={4}>
        <ErrorText>{t(Resources.Error.Error)}</ErrorText>
      </Stack>
    );
  }

  return (
    <Stack gap={4}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>{pointsTile}</Grid>
        <Grid size={{ xs: 12, sm: 6 }}>{payoutTile}</Grid>
        <Grid size={{ xs: 12, sm: 6 }}>{rewardsTile}</Grid>
        <Grid size={{ xs: 12, sm: 6 }}>{myShareTile}</Grid>
      </Grid>
      <Box display="flex" justifyContent="center">
        {rulesLink}
      </Box>
    </Stack>
  );
};
